import React from "react";
import './PartnersDiscountsPage.css';
import vyce from '../Assets/Images/vyce.png';
import casualputt from '../Assets/Images/casualputt.png';

const PartnersDiscountsPage = () => {
  // Static partner data with website link added
  const partners = [
    {
      id: 1,
      // name: 'Chipp Golf Co',
      description: 'Use code 78E7H4BRT',
      logo_url: 'https://d3k81ch9hvuctc.cloudfront.net/company/VeGsEh/images/9d8ddc06-b8eb-443d-89d9-f06b33a25899.png', // Replace with actual logo URL if available
      discount_percentage: 20,
      website: 'https://www.chippgolfco.com/discount/78E7H4BRT'
    },
   {
     id: 2,
     // name: 'Tally Tumbler',
     description: 'Use code TALLYGOLFIQ',
     logo_url: 'https://www.tallytumbler.com/cdn/shop/files/png_tally.PNG?v=1615926418&width=220',
     discount_percentage: 20,
     website: 'https://www.tallytumbler.com/'
   },
   {
   id: 3,
      name: 'VYCE Drinkware',
      description: 'Use code privateiq20',
      logo_url: vyce,
      discount_percentage: 20,
      website: 'https://www.vycedrinkware.com/'
    },
      {
   id: 4,
      //name: 'casualwear for the obsessed golfer',
      description: 'casualwear for the obsessed golfer...use code PRIVATEIQ20',
      logo_url: casualputt,
      discount_percentage: 20,
      website: 'https://casualputt.com/'
    },
  ];

  return (
    <div className="partners-discounts-container">
      <header className="partners-discounts-header">
        <h3>Member Discounts</h3>
      </header>
      <section className="partners-section">
        {partners.length > 0 ? (
          <div className="partners-list">
            {partners.map((partner) => (
              <div key={partner.id} className="partner-card">
                {partner.logo_url && (
                  <img
                    src={partner.logo_url}
                    alt={`${partner.name} logo`}
                    className="partner-logo"
                  />
                )}
                <div className="partner-details">
                  <h2>{partner.name}</h2>
                  <p>{partner.description}</p>
                  <p className="discount">{partner.discount_percentage}% Off</p>
                  {partner.website && (
                    <a
                      href={partner.website}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="partner-link"
                    >
                      Visit Website
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="empty-state">
            <p>No partners available at this time.</p>
          </div>
        )}
      </section>
    </div>
  );
};

export default PartnersDiscountsPage;
